//require('dotenv').config()

export default {
  URL_SERVER: "/api/v1",
};
